export default [
  {
    path: '/validador-contabil',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Validador Contábil Historico',
        path: 'historico',
        component: () => import('@/views/validadorContabil/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Validador Contábil' }]
        }
      },
      {
        name: 'Validador Contábil Adicionar',
        path: 'edit',
        component: () => import('@/views/validadorContabil/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Validador Contábil', path: '/validador-contabil/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Validador Contábil Editar',
        path: 'edit/:id',
        component: () => import('@/views/validadorContabil/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Validador Contábil', path: '/validador-contabil/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
